import React from 'react';

const LogoClio = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#5A67D8"/>
    <path d="M16 14C16 12.8954 16.8954 12 18 12H30C31.1046 12 32 12.8954 32 14V34C32 35.1046 31.1046 36 30 36H18C16.8954 36 16 35.1046 16 34V14Z" fill="white"/>
    <path d="M20 18H28V20H20V18Z" fill="#5A67D8"/>
    <path d="M20 23H28V25H20V23Z" fill="#5A67D8"/>
    <path d="M20 28H24V30H20V28Z" fill="#5A67D8"/>
  </svg>
);

export default LogoClio;
